export default __webpack_public_path__ + "static/media/close.dfbcaedc.svg";